import { render } from "./manage-programs-empty.vue?vue&type=template&id=9b378dea&lang=pug"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__